import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ModalCloseButton } from "../common/modal-close-button";
import { VoiceTemplateItemData } from "@/services/user-audio-template-list";
import { VoiceCard } from "../assets-voice/voice-card";
import { TemplateEmpty2Icon, TemplateEmptyIcon } from "../agent-dashboard-user-detail/assets";
import { VoiceAddButton } from "../agent-creation/voice-add-button";


export const PanelAgentVoice: React.FC<{
  open: boolean;
  templates?: VoiceTemplateItemData[];
  saveLoading: boolean;
  onSaveVoiceTemplate: (voiceIds: string[]) => Promise<void>;
  onRemoveVoiceTemplate: (voiceId: string) => Promise<void>;
  onOpenChange: (open: boolean) => void;
}> = ({ open, onOpenChange, templates = [], saveLoading, onSaveVoiceTemplate, onRemoveVoiceTemplate }) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/0" />
        <Dialog.Content
          className="
            fixed right-0 top-0 z-50 h-full w-[480px]
            bg-white flex flex-col
            data-[state=open]:translate-x-0 data-[state=closed]:translate-x-full
            transition-transform duration-300 overflow-hidden
          "
        >
          {/* 头部 */}
          <div className="flex items-center justify-between my-6 px-6">
            <div
              className="flex items-center gap-4 text-[rgba(16,24,40,1)]"
            >
              <ModalCloseButton
                icon={<ChevronLeft className="w-5 h-5" />}
                onClick={() => onOpenChange(false)}
              />
              <div className="text-base font-medium">
                {t("agent_creation.subscription_settings.voice")}
              </div>
            </div>
            <ModalCloseButton
              onClick={() => onOpenChange(false)}
            />
          </div>

          {/* 声音列表 */}
          <div className={cn(
            "flex flex-col flex-1 gap-3 px-6 overflow-y-auto pb-10",
          )}>
            <VoiceAddButton
              voiceIds={templates?.map((item) => item.id)}
              saveLoading={saveLoading}
              onSave={onSaveVoiceTemplate}
            />
            {templates?.length ? templates?.map((v, i) => (
              <VoiceCard
                showEdit={false}
                key={`${v.id}_${i}`}
                className='flex-shrink-0'
                showRemove
                audio={{
                  id: v.id,
                  voiceTtsId: "",
                  modelName: "",
                  name: v.name,
                  createdAt: v.createdAt,
                  ageGroup: "",
                  language: "",
                  gender: "",
                  speed: 1,
                  audioUrl: v.sampleUrl,
                  isStarred: false,
                }}
                onRemove={onRemoveVoiceTemplate}
              />
            )) : (
              <div className=' w-full h-full relative flex flex-col justify-center items-center col-span-full gap-2 mb-20'>
                <TemplateEmpty2Icon className='w-[198px]' />
                <span className='text-sm text-[rgba(102,112,133,1)]'>{t("agent_dashboard.user_detail.voice.voice_empty2")}</span>
              </div>
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
